export default __webpack_public_path__ + "static/media/Kat Kun Stick Salmon Flavour.5079ac21.png";